import React, {Component} from 'react';
import './styles.css';
import classNames from 'classnames';
import Tappable from 'react-tappable';


class ScrollButton extends Component {

  state ={
    intervalId: 0,
  };

  scrollStep = ()=> {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  };

  scrollToTop = (e)=> {
    e.preventDefault();
    let intervalId = setInterval(this.scrollStep, this.props.delayInMs);
    this.setState({ intervalId: intervalId});
  };

  render () {
    return (
      <Tappable onTap={this.scrollToTop} title='Back to top' className={classNames('scroll', {'show-scroll-button':this.props.showScrollButton})}>
        <i className="fa fa-angle-up fa-2x" aria-hidden="true"> </i>
        <p>Back to Top</p>
    </Tappable>
  )
  }
}

export default ScrollButton;


// WEBPACK FOOTER //
// ./src/components/common/ScrollButton/ScrollButton.js